// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ChevronUpAndDown = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M69.414 38.914a2 2 0 0 0 0-2.828l-20-20a2 2 0 0 0-2.828 0l-20 20a2 2 0 1 0 2.828 2.828L48 20.329l18.586 18.585c.39.39.902.586 1.414.586.512 0 1.023-.195 1.414-.586M48 80.5a1.99 1.99 0 0 1-1.414-.586l-20-20a2 2 0 1 1 2.828-2.828L48 75.672l18.586-18.586a2 2 0 1 1 2.828 2.828l-20 20A1.992 1.992 0 0 1 48 80.5"
			fillRule="evenodd"
		/>
	</svg>
);
export default ChevronUpAndDown;
